export default __webpack_public_path__ + "static/media/position.3c25daad.svg";